'use strict';
import * as $j_java$002elang$002e$002dObject from "./java.lang.-Object.js";
import * as $j_samples$002e$002dSealed$0024package$0024$002dAnimal$00241 from "./samples.-Sealed$package$-Animal$1.js";
var $p;
/** @constructor */
function $c_Lsamples_Sealed$package$$anon$35(evaluator$22) {
  this.LQ = null;
  this.LQ = evaluator$22;
}
export { $c_Lsamples_Sealed$package$$anon$35 as $c_Lsamples_Sealed$package$$anon$35 };
$p = $c_Lsamples_Sealed$package$$anon$35.prototype = new $j_java$002elang$002e$002dObject.$h_O();
$p.constructor = $c_Lsamples_Sealed$package$$anon$35;
/** @constructor */
function $h_Lsamples_Sealed$package$$anon$35() {
}
export { $h_Lsamples_Sealed$package$$anon$35 as $h_Lsamples_Sealed$package$$anon$35 };
$h_Lsamples_Sealed$package$$anon$35.prototype = $p;
$p.b = (function() {
  return "<function0>";
});
$p.v = (function() {
  var v = this.LQ.h();
  return ($j_samples$002e$002dSealed$0024package$0024$002dAnimal$00241.$is_Lsamples_Sealed$package$Animal$1(v) ? new $j_java$002elang$002e$002dObject.$c_s_Some(v) : $j_java$002elang$002e$002dObject.$m_s_None$());
});
$p.h = (function() {
  return this.v();
});
var $d_Lsamples_Sealed$package$$anon$35 = new $j_java$002elang$002e$002dObject.$TypeData().i($c_Lsamples_Sealed$package$$anon$35, "samples.Sealed$package$$anon$35", ({
  qd: 1,
  d: 1,
  a: 1,
  f: 1
}));
export { $d_Lsamples_Sealed$package$$anon$35 as $d_Lsamples_Sealed$package$$anon$35 };
